var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('loader',{attrs:{"is-visible":_vm.isLoading,"text":"Loading..."}}),_vm._v(" "),_c('processing',{attrs:{"is-visible":_vm.isProcessing}}),_vm._v(" "),_c('MessageBox',{ref:"MessageBox"}),_vm._v(" "),_c('FlashMessage',{ref:"FlashMessage"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a05a495","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 